module.exports = __webpack_public_path__ + "img/slide_003_b.f92014db.jpg";